if (typeof window != "undefined")
  require("./iconpark.js");
import convert from 'htmr';
import React from "react";
export default function SvgIcon({ src, icon, style, onClick, className, colorStroke, colorNoChange }) {
  if (icon)
    return (
      <svg className="iconpark-icon" style={style}>
        <use href={"#" + icon}></use>
      </svg>
    );
  else {
    if (style || onClick || className) {
      const transform = {
        _: (nodeName, props, children) => {
          if (nodeName === 'svg') {
            props.style = style;
            props.onClick = onClick;
            if(className)
              props.className = className;
          }
          else if(nodeName == 'lineargradient')
          {
            nodeName = 'linearGradient';
          }
          else if (nodeName === 'path' && style && style.color && !colorNoChange) {
            if(colorStroke)
            {
              props.stroke = "currentColor";
            }
            else
            {
              props.fill = "currentColor";
            }
          }
          return React.createElement(nodeName, props, children);
        }
      }
      return convert(src, { transform });
    }
    return convert(src);
  }
}